import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Text,
  VStack,
  useToast,
} from '@chakra-ui/react';
import { ResStatus } from 'lib/api/enum';
import { channelState } from 'lib/atoms/secureState';
import usePathNavigate from 'lib/hook/usePathNavigate';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { home_menus } from '../../assets/data';
import CompanyInfo from '../../components/CompanyInfo';
import { useMutation } from '@tanstack/react-query';
import { callAccountLogout, callB2BsignApi } from './api';
import ExternalLinkModal from 'components/ExternalLinkModal';
import withAuth from 'lib/hook/withAuth';
import SnsModal from 'components/SnsModal';

function Home() {
  const { pathNavigate } = usePathNavigate();
  // http://192.168.0.26:3000/?c=bybtheh&t=eyJjaGFubmVsIjoiYnlidGhlaCIsInVzZXIiOiIxODhiMGQyNzg1MmRiZDQ4ZTk0NWUzZWRjMDJmZmQ3NTkwOTY3MTZhOTM0Nzg0MDgwMWI4NDg4Nzg3ZGQ1ODYxYWMyNTQ0Y2E5NjY4MjY4YTkwN2UyOWIxYjdhZTZiNzliMzRjZGRlM2EwOWMxZjQ0NGQ0N2ZjMzYxNWRkZmZmNiIsInRpbWVzdGFtcCI6MTY4MDY5NjM5MjczNX0=
  const location = useLocation();
  const toast = useToast();
  const query = queryString.parse(location.search);
  const [isOpen, setIsOpen] = useState(false);
  const [url, setUrl] = useState('');
  const [isOpenSns, setIsOpenSns] = useState(false);

  const [loaded, setLoaded] = useState(false);
  const [channel] = useRecoilState(channelState);

  const { mutate: b2bSignMutate } = useMutation(callB2BsignApi, {
    onSuccess: (data) => {
      // console.log('#############', data);
      if (data.status === ResStatus.RES_SUCCESS) {
        localStorage.setItem('channel', data.channel ?? 'apps');
        setLoaded(true);
        toast({
          description: '로그인 되었습니다.',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
        pathNavigate('/', { replace: true });
      } else if (
        data.status === ResStatus.RES_SNS_AUTHENTICATION_FAILED ||
        data.status === ResStatus.RES_SNS_CHANNEL_FAILED
      ) {
        deleteSnsInfo();
        localStorage.setItem('channel', data.channel ?? 'apps');
        setLoaded(true);
        toast({
          description: '로그인 실패하였습니다. 다시 시도해주시기 바랍니다.',
          status: 'warning',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      } else {
        toast({
          title: '실패',
          description: data.result_message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    },
    onError: (error: any) => {
      console.log('error : ', error);
      toast({
        title: '오류',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    },
  });
  const { mutate: accountLogout } = useMutation(callAccountLogout, {
    onSuccess: (data) => {
      if (data.status === ResStatus.RES_SUCCESS) {
        deleteSnsInfo();
        toast({
          description: '로그아웃 되었습니다',
          status: 'warning',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      } else if (
        data.status === ResStatus.RES_UNAUTHORIZED ||
        data.status === ResStatus.RES_SNS_REQUEST_FAILED
      ) {
        toast({
          title: '로그아웃 실패',
          description:
            data.status === ResStatus.RES_UNAUTHORIZED
              ? '권한이 없어 로그아웃 할 수 없습니다. 다시 시도해주시기 바랍니다.'
              : '로그아웃 실패하였습니다. 다시 시도해주시기 바랍니다.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      } else {
        toast({
          title: '실패',
          description: data.result_message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    },
    onError: (error: any) => {
      console.log('error : ', error);
      toast({
        title: '오류',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    },
  });

  const checkSnsLogin = () => {
    if (query.c) {
      const c = query.c.toString();
      if (c !== 'smcare' && c !== 'cosmocare') {
        return false;
      }
    }

    const accessToken = localStorage.getItem('accessToken');
    // console.log('accessToken : ', accessToken);

    if (accessToken === null || accessToken === '401') {
      setIsOpenSns(true);
      return true;
    }
    return false;
  };

  const onOrderHandler = async () => {
    // temp
    // pathNavigate('/requests/order');

    if (checkSnsLogin()) {
      return;
    }
    const accessToken = localStorage.getItem('accessToken');
    // console.log('accessToken : ', accessToken);

    if (accessToken === null)
      pathNavigate('/secure/certification?page=/requests/estimate');
    else pathNavigate('/requests/order');
  };

  const onEstimateHandler = async () => {
    const accessToken = localStorage.getItem('accessToken');
    // console.log('accessToken : ', accessToken);

    if (accessToken === null)
      pathNavigate('/secure/certification?page=/requests/estimate');
    else pathNavigate('/requests/estimate');
  };

  const onMenuHandler = async (index: number) => {
    const menu_channel =
      localStorage.getItem('channel') === 'smcare'
        ? 'smcare'
        : localStorage.getItem('channel') === 'cosmocare'
          ? 'cosmocare'
          : 'other';
    switch (index) {
      case 0: // 이용가이드
      case 3: // FAQ
        setUrl(home_menus[menu_channel][index].link);
        setIsOpen(true);
        break;
      case 1: // 주문내역
      case 2: // 제품내역
        if (checkSnsLogin()) {
          return;
        }
        pathNavigate(home_menus[menu_channel][index].link);
        break;
    }
  };

  const onClose = () => {
    setIsOpen(false);
    setUrl('');
  };

  const onCloseSns = () => {
    setIsOpenSns(false);
  };

  const deleteSnsInfo = () => {
    if (localStorage.getItem('login_type') === 'naver') {
      localStorage.removeItem('com.naver.nid.oauth.state_token');
    } else if (localStorage.getItem('login_type') === 'kakao') {
    }
    localStorage.removeItem('login_type');
    localStorage.removeItem('login_token');
    localStorage.removeItem('accessToken');
    // sessionStorage.clear();
  };

  // https://nid.naver.com/oauth2.0/token?grant_type=delete&client_id=rKJ47iQjyegvOd_IhT1s&client_secret=tkLXiea7hd&access_token=AAAANT4_KrxDccZT7pPjWdaJ2DUT3gHsLRm7A-vpcZOwYVMw3oEPtZxWqxRtmPcdy4rB3_PJsxWofqQu7B-7ZmgxVX0&service_provider=NAVER
  const onLogout = () => {
    accountLogout();
    // deleteSnsInfo();
  };

  useEffect(() => {
    // console.log(
    //   'storage, qc, qt: ',
    //   localStorage.getItem('channel'),
    //   query.c,
    //   query.t
    // );
    if (query.c && query.t === undefined) {
      const c = query.c.toString();
      if (c === 'smcare' || c === 'cosmocare') {
        const ltoken = localStorage.getItem('login_token');
        // console.log('ltoken', ltoken);
        if (ltoken !== null && ltoken !== '') {
          b2bSignMutate({
            channel: c,
            external_token: localStorage.getItem('login_type') + ltoken,
            useragent: window.navigator.userAgent,
          });
        } else {
          localStorage.setItem('channel', c ?? 'apps');
          setLoaded(true);
        }
      }
    } else if (query.c && query.t) {
      const c = query.c.toString();
      const t = query.t.toString();
      const existChannel = channel
        .map((ch) => ch.channel_code)
        .some((v) => v === query.c);

      // console.log('exist channel', c, t);

      if (existChannel) {
        b2bSignMutate({
          channel: c,
          external_token: t,
          useragent: window.navigator.userAgent,
        });
      }
    } else if (localStorage.getItem('channel')) {
      // console.log(localStorage.getItem('channel'));

      setLoaded(true);
    } else {
      // console.log('!!!!!!!!!');
      pathNavigate('*', { replace: true });
    }
  }, []);

  const gotoChat = () => {
    const channel = localStorage.getItem('channel');
    if (channel === 'bybtheh') {
      window.open('http://pf.kakao.com/_zsiQxj/chat', '_blank');
    } else if (channel === 'smcare') {
      window.open('http://pf.kakao.com/_clxbxmK/chat', '_blank');
    } else if (channel === 'cosmocare') {
      window.open('http://pf.kakao.com/_eUxkxmG/chat', '_blank');
    } else {
      window.open('http://pf.kakao.com/_Nsvixj/chat', '_blank');
    }
  };

  if (!loaded) {
    return <Box></Box>;
  }

  return (
    <Flex flexDirection="column" alignItems={'center'} position={'relative'}>
      <Flex mt={'12px'} h="32px" justifyContent={'flex-end'} w="100%"></Flex>
      <Box mt="45px" w={'160px'} h="160px" bg={'gray.100'}>
        <Image
          src={`https://mintwk.edge.naverncp.com/mint-house/logo_${localStorage.getItem(
            'channel',
          )}.png`}
          w="full"
          h="full"
          fit={'contain'}
        />
      </Box>
      <HStack
        mt={'41px'}
        w={'100%'}
        px={'34px'}
        justifyContent={'space-between'}>
        {home_menus[
          localStorage.getItem('channel') === 'smcare'
            ? 'smcare'
            : localStorage.getItem('channel') === 'cosmocare'
              ? 'cosmocare'
              : 'other'
        ].map((menu, index) => (
          <VStack
            key={index}
            spacing={'5px'}
            onClick={() => onMenuHandler(index)}>
            <Image src={`/assets/images/${menu.icon}`} />
            <Text fontSize={'13px'} fontWeight="normal">
              {menu.name}
            </Text>
          </VStack>
        ))}
      </HStack>
      <VStack w={'100%'} px={'20px'} mt="42px" mb="129px" gap={'10px'}>
        <Button
          colorScheme={'mint'}
          w="100%"
          h={'56px'}
          fontSize={'14px'}
          fontWeight="semibold"
          onClick={onOrderHandler}>
          <Image
            src="/assets/images/icn_webordermenu5.svg"
            position="absolute"
            left={'27px'}
          />
          서비스 주문하기
        </Button>
        <Button
          hidden={
            (localStorage.getItem('channel') !== 'smcare' &&
              localStorage.getItem('channel') !== 'cosmocare') ||
            localStorage.getItem('accessToken') === '401' ||
            localStorage.getItem('accessToken') === null
          }
          variant={'plain'}
          w="80px"
          h={'40px'}
          fontSize={'14px'}
          fontWeight="semibold"
          color={'#128cfe'}
          textDecoration="underline"
          onClick={onLogout}>
          로그아웃
        </Button>
      </VStack>
      <CompanyInfo />

      <ExternalLinkModal isOpen={isOpen} url={url} onClose={onClose} />
      <SnsModal isOpen={isOpenSns} onClose={onCloseSns} />
      <Box
        w={'68px'}
        h={'68px'}
        onClick={gotoChat}
        position={'absolute'}
        bottom={'20px'}
        right={'16px'}>
        <Image src="/assets/images/kakao_68x68.svg" />
      </Box>
    </Flex>
  );
}
export default withAuth(Home);
